import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Modal, useScreenQuery } from 'playup-web-core';
import useNotify from '../../../hooks/useNotify';
import appConfig from '../../../appConfig';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import { closeAccount } from '../../../api/users';
import { parseApiError } from '../../../utils/parseApiError';
import { PageContainer } from 'playup-web-core/src/pageComponents/PortalMenu/sharedStyles';
import UsContent from './USContent';
import AUContent from './AUContent';
import { TitleHeader } from 'playup-web-core/src/pageComponents/PortalMenu/sharedStyledComponents';
import USstateConfig from '../../constants/USstateConfig';

const isUS = appConfig.regions.isUS;
const usState = appConfig.regions.usState;
const brandName = appConfig.brand.name;
const responsibleGamblingUrl = appConfig.brand.urls.responsible_gambling_policy;
const termsUrl = appConfig.brand.urls.terms;

const CloseAccount: React.FC = () => {
	const { logout } = React.useContext(PortalSessionContext);
	const [sending, setSending] = React.useState<boolean>(false);
	const [errors, setErrors] = React.useState<APIError>();
	const { isSmall } = useScreenQuery();
	const [showModal, setShowModal] = React.useState(false);

	const history = useHistory();
	const notify = useNotify();

	const handleSubmit = () => {
		setSending(true);
		setErrors(undefined);

		closeAccount()
			.then(() => {
				notify({
					type: 'success',
					title: 'Success',
					message: 'Your account has been closed. You are now logged out.',
				});
				logout();
				history.push('/');
			})

			.catch((error) => {
				setErrors(error.errors);
			})
			.finally(() => {
				setSending(false);
			});
	};
	const errorMessage = errors && errors.error && parseApiError(errors);

	return (
		<>
			<Helmet title="Close Account" />
			{isSmall && <TitleHeader title={'Close Account'} />}
			<PageContainer isSmallScreen={isSmall}>
				{isUS ? (
					<UsContent
						usState={usState}
						brandName={brandName}
						isSmall={isSmall}
						showConfirm={() => setShowModal(true)}
						usStateConfig={USstateConfig[usState]}
						errorMessage={errorMessage}
					/>
				) : (
					<AUContent
						termsUrl={termsUrl}
						brandName={brandName}
						isSmall={isSmall}
						responsibleGamblingUrl={responsibleGamblingUrl}
						showConfirm={() => setShowModal(true)}
						errorMessage={errorMessage}
					/>
				)}
				{showModal && (
					<Modal onClose={() => setShowModal(false)} title="Confirm Close Account">
						<ModalText isSmallScreen={isSmall}>
							Please note that this is a firm commitment. You will NOT be able to login to this account.
						</ModalText>
						<Button isLoading={sending} kind="danger" height={50} onClick={handleSubmit}>
							Close Account
						</Button>
						<Button height={50} onClick={() => setShowModal(false)}>
							Cancel
						</Button>
					</Modal>
				)}
			</PageContainer>
		</>
	);
};

export default CloseAccount;

const ModalText = styled.p<{ isSmallScreen: boolean }>`
	text-align: center;
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
`;
